<template>
  <header>
    <div class="container-fluid h-100">
      <div class="row align-items-center h-100">
        <div class="col-lg-4 col-auto order-lg-1 order-1">
          <div class="d-flex align-items-center gap-2 navTrigger-wrap">
            <div class="navTrigger">
              <i></i>
              <i></i>
              <i></i>
            </div>
            <div class="paragraph--small text-color-quinary text-uppercase d-none d-lg-block">
              MENU
            </div>
          </div>
        </div>
        <div class="col-lg-4 col order-lg-2 order-2">
          <a href="/" class="d-block text-center header-logo">
            <img src="/frontend/assets/svg/logo.svg" alt="Company Logo" />
          </a>
          <div class="menu-wrap">
            <nav class="col-sm primary-menu">
              <ul>
                <li><router-link to="/inventory" @click="scrollToTop">CARS FOR SALE</router-link></li>
                <li><router-link to="/sold-cars">SOLD CARS</router-link></li>
                <li>
                  <router-link to="/car-on-request">CAR ON REQUEST</router-link>
                </li>
                <li><router-link to="/services">SERVICES</router-link></li>
                <li><router-link to="/about">ABOUT US </router-link></li>
                <li><router-link to="/contacts">CONTACTS</router-link></li>
              </ul>
            </nav>

            <div
              class="row align-items-center justify-content-sm-between w-100 mt-auto col-sm-auto"
            >
              <div class="col-sm-auto mb-sm-0 mb-3">
                <div class="d-flex align-items-center gap-3">
                  <div class="icon-circle">
                    <Icon icon="ic:baseline-local-phone" class="iconify" />
                  </div>
                  <span class="paragraph--large text-color-quinary"
                    >{{ headquarters.phone || '+421 949 006 016' }}</span
                  >
                </div>
              </div>
              <div class="col-sm-auto ms-auto">
                <div class="d-flex align-items-center gap-3">
                  <div class="icon-circle">
                    <Icon icon="ic:sharp-email" class="iconify" />
                  </div>
                  <span class="paragraph--large text-color-quinary"
                    >{{ headquarters.email || 'info@selected.sk' }}</span
                  >
                </div>
              </div>
            </div>
            <div class="menu-join-block">
              <div class="menu-join-block--left">
                <img src="/frontend/assets/images/car_join.jpg" alt="Car Join Image" />
              </div>
              <div class="menu-join-block--right">
                <div class="paragraph--mini wide text-color-quinary mb-2">
                  PRIVATE TELEGRAM
                </div>
                <div class="paragraph--medium text-color-senary mb-1">
                  Get exclusive offers of cars as first in our Telegram private
                  group
                </div>
                <a
                  href="https://t.me/selectedslovakia"
                  target="_blank"
                  class="d-flex align-items-center justify-content-end gap-2 text-decoration-none"
                >
                  <div
                    class="paragraph--mini wide text-color-quinary text-uppercase"
                  >
                    JOIN
                  </div>
                  <Icon
                    icon="uil:telegram"
                    class="iconify text-color-quinary"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Mobile language switcher (right side) -->
        <div class="col-auto d-lg-none order-3">
          <div class="lang-switcher-header notranslate" translate="no">
            <div class="lang-btn-mobile" @click.stop="mobileLangOpen = !mobileLangOpen" v-click-outside="() => mobileLangOpen = false">
              <span>{{ currentLangFlag }}</span>
              <Icon icon="mdi:chevron-down" class="iconify lang-arrow-sm" :class="{ 'open': mobileLangOpen }" />
            </div>
            <div class="lang-menu-mobile" v-show="mobileLangOpen">
              <div
                v-for="lang in languages"
                :key="lang.code"
                class="lang-option-m"
                :class="{ 'active': lang.code === currentLang }"
                @click="switchLang(lang.code); mobileLangOpen = false"
              >
                {{ lang.flag }} {{ lang.label }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 d-lg-block d-none order-lg-3">
          <div class="row align-items-center justify-content-end">
            <div class="col-auto ps-0 social-btn-wrap">
              <a
                href="https://instagram.com/selected_sk"
                class="btn btn--normal btn--primary text-uppercase"
                aria-label="Visit Instagram"
                target="_blank"
              >
                <Icon icon="uil:instagram-alt" class="iconify" />INSTAGRAM
              </a>
            </div>
            <div class="col-auto ps-0 social-btn-wrap">
              <a
                href="https://t.me/selectedslovakia"
                target="_blank"
                class="btn btn--normal btn--primary text-uppercase"
                aria-label="Visit Telegram"
              >
                <Icon icon="uil:telegram" class="iconify" />TELEGRAM
              </a>
            </div>
            <div class="col-auto ps-0 social-btn-wrap lang-switcher notranslate" translate="no">
              <div class="btn btn--normal btn--primary text-uppercase lang-dropdown" @click.stop="langOpen = !langOpen" v-click-outside="() => langOpen = false">
                <span>{{ currentLangFlag }} {{ currentLangLabel }}</span>
                <Icon icon="mdi:chevron-down" class="iconify lang-arrow" :class="{ 'open': langOpen }" />
              </div>
              <div class="lang-menu" v-show="langOpen">
                <div
                  v-for="lang in languages"
                  :key="lang.code"
                  class="lang-option"
                  :class="{ 'active': lang.code === currentLang }"
                  @click="switchLang(lang.code)"
                >
                  {{ lang.flag }} {{ lang.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { Icon } from '@iconify/vue';
import { ref, computed, onMounted } from 'vue';
import axios from 'axios';

const headquarters = ref({
  phone: '+421 949 006 016',
  email: 'info@selected.sk',
  address: ''
});

const currentLang = ref('en');
const langOpen = ref(false);
const mobileLangOpen = ref(false);

const languages = [
  { code: 'en', label: 'EN', gtCode: 'en', flag: '\u{1F1EC}\u{1F1E7}' },
  { code: 'de', label: 'DE', gtCode: 'de', flag: '\u{1F1E9}\u{1F1EA}' },
  { code: 'sk', label: 'SK', gtCode: 'sk', flag: '\u{1F1F8}\u{1F1F0}' },
  { code: 'cs', label: 'CZ', gtCode: 'cs', flag: '\u{1F1E8}\u{1F1FF}' },
  { code: 'pl', label: 'PL', gtCode: 'pl', flag: '\u{1F1F5}\u{1F1F1}' },
  { code: 'it', label: 'IT', gtCode: 'it', flag: '\u{1F1EE}\u{1F1F9}' },
  { code: 'zh', label: 'ZH', gtCode: 'zh-CN', flag: '\u{1F1E8}\u{1F1F3}' },
  { code: 'ar', label: 'UAE', gtCode: 'ar', flag: '\u{1F1E6}\u{1F1EA}' },
  { code: 'ru', label: 'RU', gtCode: 'ru', flag: '\u{1F1F7}\u{1F1FA}' },
];

const currentLangLabel = computed(() => {
  const lang = languages.find(l => l.code === currentLang.value);
  return lang ? lang.label : 'EN';
});

const currentLangFlag = computed(() => {
  const lang = languages.find(l => l.code === currentLang.value);
  return lang ? lang.flag : '\u{1F1EC}\u{1F1E7}';
});

function switchLang(code) {
  const lang = languages.find(l => l.code === code);
  if (!lang) return;

  currentLang.value = code;
  langOpen.value = false;

  // Trigger Google Translate
  const gtSelect = document.querySelector('.goog-te-combo');
  if (gtSelect) {
    gtSelect.value = lang.gtCode;
    gtSelect.dispatchEvent(new Event('change'));
  }
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

// v-click-outside directive
const vClickOutside = {
  mounted(el, binding) {
    el._clickOutside = (e) => {
      if (!el.contains(e.target)) binding.value();
    };
    document.addEventListener('click', el._clickOutside);
  },
  unmounted(el) {
    document.removeEventListener('click', el._clickOutside);
  }
};

onMounted(async () => {
  try {
    const response = await axios.get('/api/visible-agents');
    if (response.data.headquarters) {
      headquarters.value = response.data.headquarters;
    }
  } catch (error) {
    console.error('Error fetching headquarters data:', error);
  }

  // Detect current Google Translate language from cookie
  const match = document.cookie.match(/googtrans=\/en\/([a-z-]+)/i);
  if (match) {
    const gtLang = match[1];
    const found = languages.find(l => l.gtCode === gtLang || l.gtCode.startsWith(gtLang));
    if (found) currentLang.value = found.code;
  }
});
</script>

<style scoped>
.social-btn-wrap .btn {
  font-size: 0.5rem;
  padding: 0.25rem 0.55rem;
  letter-spacing: 0.1em;
}

.social-btn-wrap .btn .iconify {
  font-size: 0.7rem;
}

/* Language Switcher - Desktop */
.lang-switcher {
  position: relative;
}

.lang-dropdown {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.lang-arrow {
  font-size: 14px;
  transition: transform 0.2s;
  margin-left: 2px;
}

.lang-arrow.open {
  transform: rotate(180deg);
}

.lang-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: #1a1a1a;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  min-width: 160px;
  z-index: 1000;
  overflow: hidden;
  max-height: 400px;
  overflow-y: auto;
}

.lang-option {
  padding: 12px 20px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  letter-spacing: 0.1em;
  cursor: pointer;
  transition: background 0.15s;
}

.lang-option:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.lang-option.active {
  color: #fff;
  font-weight: 600;
}

/* Mobile header language switcher */
.lang-switcher-header {
  position: relative;
}

.lang-btn-mobile {
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  font-size: 1.1rem;
  color: #fff;
  padding: 4px;
}

.lang-arrow-sm {
  font-size: 12px;
  transition: transform 0.2s;
  opacity: 0.5;
}

.lang-arrow-sm.open {
  transform: rotate(180deg);
}

.lang-menu-mobile {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background: #1a1a1a;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  min-width: 130px;
  z-index: 1000;
  overflow: hidden;
  max-height: 360px;
  overflow-y: auto;
}

.lang-option-m {
  padding: 10px 16px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  letter-spacing: 0.1em;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}

.lang-option-m:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.lang-option-m.active {
  color: #fff;
  font-weight: 600;
}
</style>
